import React from "react";
import { VerticalNavItem } from "./VerticalNavItem";
import { SubPhases } from "../constants/Questions";

export function VerticalNav({
  selectedPhase,
  selectedSubPhase,
  setSelectedSubPhase,
}: {
  selectedPhase: number;
  selectedSubPhase: number;
  setSelectedSubPhase: (p: number) => void;
}) {
  const allSubPhases = SubPhases.filter((p) => p.phase === selectedPhase).sort(
    (a, b) => a.position - b.position
  );
  const foundSelected = allSubPhases.find((p) => p.id === selectedSubPhase);

  return (
    <div className="flex nav vertical flex-column">
      {allSubPhases.map((p, index) => {
        return (
          <VerticalNavItem
            active={
              foundSelected !== undefined &&
              p.position <= foundSelected.position
            }
            dividerActive={
              foundSelected !== undefined && p.position < foundSelected.position
            }
            number={index + 1}
            text={p.name}
            onClick={() => {
              setSelectedSubPhase(p.id);
            }}
            last={index === allSubPhases.length - 1}
            key={index}
          />
        );
      })}
    </div>
  );
}
